import { render, staticRenderFns } from "./LinkDialog.vue?vue&type=template&id=efe207a8&scoped=true&"
import script from "./LinkDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LinkDialog.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LinkDialog.vue?vue&type=style&index=0&id=efe207a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe207a8",
  null
  
)

export default component.exports